export const formatViewers = (count: number): string => {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return `${count}`;
};

export const formatFollowers = (count: number): string => {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return `${count}`;
};

export const formatStartTime = (iso: string): string => {
  const date = new Date(iso);
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  const hour = `${date.getHours()}`.padStart(2, "0");
  const minute = `${date.getMinutes()}`.padStart(2, "0");
  return `${month}-${day} ${hour}:${minute}`;
};

export const statusLabel = (status: string): string =>
  status === "live" ? "直播中" : "已结束";

export const regionLabel = (region: string): string =>
  region === "domestic" ? "国内" : "国际";

export const levelLabel = (level: string): string =>
  level === "vip" ? "VIP 主播" : "普通主播";